"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyInfo = void 0;
// eslint-disable-next-line max-classes-per-file
const three_1 = require("three");
// eslint-disable-next-line import/no-cycle
const types_1 = require("~/store/types");
// eslint-disable-next-line import/no-cycle
const consts_1 = require("~/consts/consts");
const consts_2 = require("~/store/consts");
const catalogUtils_1 = require("~/utils/catalogUtils");
const types_2 = require("../../../store/common/types");
const consts_3 = require("../consts");
const consts_4 = require("../consts/consts");
// eslint-disable-next-line import/no-cycle
const PartMetadata_1 = __importDefault(require("./PartMetadata"));
// eslint-disable-next-line import/no-cycle
const utils_1 = require("../utils");
// eslint-disable-next-line import/no-cycle
const utils_2 = require("../../../utils/utils");
// eslint-disable-next-line import/no-cycle
const utils_3d_1 = require("../utils/utils.3d");
const SlicingTool_3d_1 = __importDefault(require("./SlicingTool.3d"));
const tempMatrix4 = new three_1.Matrix4();
class CopyInfo {
    constructor() {
        this.fasteners = [];
    }
}
exports.CopyInfo = CopyInfo;
// eslint-disable-next-line no-underscore-dangle
const _v1 = new three_1.Vector3();
// eslint-disable-next-line no-underscore-dangle
const _v2 = new three_1.Vector3();
// eslint-disable-next-line no-underscore-dangle
const _q1 = new three_1.Quaternion();
// eslint-disable-next-line no-underscore-dangle
const _q2 = new three_1.Quaternion();
// eslint-disable-next-line no-underscore-dangle
const _q3 = new three_1.Quaternion();
const notMovingTypes = [types_2.COMPONENT_TYPE.END_CAP];
const notRotatingTypes = [types_2.COMPONENT_TYPE.END_CAP];
const notScalingTypes = [types_2.COMPONENT_TYPE.END_CAP];
class BaseObject3D extends three_1.Object3D {
    constructor() {
        super();
        this.snappedToAngledExtrusion = false;
        // for end-connected extrusions only
        this.snappedEndFace = null;
        this.isCollided = false;
        this.uuidsObjectsInsertedIntoPlate = [];
        this.isCustomObject = true;
        this.customScalingAxis = consts_3.consts.POSITIVE_AXES.positiveZ;
        this.extrudeDirectionUpwards = false;
        this.isRotatedForSnapping = true;
        this.snapped = false;
        this.insertedVertically = true;
        this.notFlatWise = false;
        this.partDetails = {
            itemNumber: '',
            itemType: '',
            componentType: '',
            extrusionType: '',
            extrusionProfileType: '',
            isConvex: false,
            itemLength: 1,
            isScalable: false,
            scaleAxes: '',
            maxStockLength: consts_3.consts.DEFAULT_MAX_STOCK_LENGTH,
            maxStockWidth: consts_3.consts.DEFAULT_MAX_STOCK_WIDTH,
            seriesIds: [],
            size: null,
            unitOfMeasurementId: 0,
            mountTo: [],
            includedFastenersCount: 0,
            slotThickness: 0,
            holeDepth: 0,
            panelDepth: null,
            thickness: 0,
        };
        this.partMetadata = new PartMetadata_1.default();
        this.neighborFaceDirection = consts_3.consts.AXES.negativeZ;
        this.directionNormal = consts_3.consts.DP_UP_DIR.clone();
        this.xDirection = consts_4.WORLD_AXES.X.clone();
        this.yDirection = consts_4.WORLD_AXES.Y.clone();
        this.zDirection = consts_4.WORLD_AXES.Z.clone();
        this.connectionType = types_2.CONNECTION_TYPE.PERPENDICULAR;
        this.connectedItems = [];
        this.objectSnappedToTheEdge = false;
        this.objectSnappedToTheCenter = false;
        this.slicePlanes = [];
        this.cutContour = [];
        this.oldCoord = new three_1.Vector3(0, 0, 0);
        this.snappedAt = new three_1.Vector3(0, 0, 0);
        this.metadataNeedsUpdate = false;
        this.scalingAngle = 0;
        this.additionalRotationAngle = 0;
        this.scaleOnDown = new three_1.Vector3();
        this.positionOnDown = new three_1.Vector3();
        this.quaternionOnDown = new three_1.Quaternion();
        this.hasSwappedMetadataPoints = false;
    }
    setUuidsObjectsInsertedIntoPlate() {
        if (this.type === types_2.ITEM_TYPE.COMPONENT) {
            this.uuidsObjectsInsertedIntoPlate = [];
            this.connectedItems.forEach((item) => {
                if (item.componentType) {
                    this.uuidsObjectsInsertedIntoPlate.push(item.uuid);
                }
            });
        }
    }
    select() {
        const meshMaterial = this.mesh.material;
        this.setUuidsObjectsInsertedIntoPlate();
        if (this.baseColor && meshMaterial.color) {
            meshMaterial.color = this.baseColor.clone();
            if (this.isCollided) {
                meshMaterial.color.lerp(new three_1.Color(consts_3.consts.COLLISION_BOX_COLOR), consts_3.consts.COLOR_LERP_OPACITY);
            }
            meshMaterial.color.lerp(new three_1.Color(consts_3.consts.OUTER_BOX_COLOR), consts_3.consts.COLOR_LERP_OPACITY);
        }
        else {
            this.showOuterBox();
        }
        this.showSelectionBox();
    }
    unselect() {
        const meshMaterial = this.mesh.material;
        if (this.baseColor && meshMaterial.color) {
            meshMaterial.color = this.baseColor.clone();
            if (this.isCollided) {
                meshMaterial.color.lerp(new three_1.Color(consts_3.consts.COLLISION_BOX_COLOR), consts_3.consts.COLOR_LERP_OPACITY);
            }
        }
        this.hideOuterBox();
        this.hideSelectionBox();
    }
    showOuterBox() {
        this.outerBox.visible = true;
    }
    hideOuterBox() {
        this.outerBox.visible = false;
    }
    showCollisionBox() {
        this.isCollided = true;
        this.showErrorBox();
    }
    hideCollisionBox() {
        this.isCollided = false;
        this.hideErrorBox();
    }
    showErrorBox() {
        const meshMaterial = this.mesh.material;
        if (this.baseColor && meshMaterial.color) {
            meshMaterial.color = this.baseColor.clone();
            meshMaterial.color.lerp(new three_1.Color(consts_3.consts.COLLISION_BOX_COLOR), consts_3.consts.COLOR_LERP_OPACITY);
        }
        else {
            this.collisionBox.visible = true;
        }
    }
    hideErrorBox() {
        const meshMaterial = this.mesh.material;
        if (this.baseColor && meshMaterial.color) {
            meshMaterial.color = this.baseColor.clone();
        }
        else {
            this.collisionBox.visible = false;
        }
    }
    showSelectionBox(rgbColor = consts_3.consts.SELECTION_BOX_COLOR_VECTOR) {
        this.selectionBox.visible = true;
        this.selectionBox.setColor(rgbColor);
    }
    hideSelectionBox() {
        this.selectionBox.visible = false;
    }
    copy(source, recursive = true) {
        var _a, _b;
        super.copy(source, recursive);
        this.isCustomObject = source.isCustomObject;
        this.customScalingAxis = source.customScalingAxis;
        this.insertedVertically = source.insertedVertically;
        this.metadataNeedsUpdate = source.metadataNeedsUpdate;
        this.scalingAngle = source.scalingAngle;
        this.partDetails = source.partDetails;
        this.baseColor = source.baseColor;
        this.directionNormal.copy(source.directionNormal);
        this.partMetadata.copy(source.partMetadata);
        this.xDirection.copy(source.xDirection);
        this.yDirection.copy(source.yDirection);
        this.zDirection.copy(source.zDirection);
        this.mesh = this.children[0];
        if (this.mesh) {
            if (this.mesh.material instanceof three_1.Material) {
                this.mesh.material = this.mesh.material.clone();
            }
            else {
                this.mesh.material = this.mesh.material.map((partMaterial) => partMaterial.clone());
            }
        }
        this.outerBox = this.children[1];
        this.collisionBox = this.children[2];
        this.selectionBox = this.children[3];
        this.computedInboundSnappingPointsDataInitial = utils_1.SnappingMetadataComputingUtils.cloneSnappingPointsArray(source.computedInboundSnappingPointsDataInitial);
        this.computedInboundSnappingPointsData = utils_1.SnappingMetadataComputingUtils.cloneSnappingPointsArray(source.computedInboundSnappingPointsData);
        this.computedOutboundSnappingPointsDataInitial = utils_1.SnappingMetadataComputingUtils.cloneSnappingPointsArray(source.computedOutboundSnappingPointsDataInitial);
        this.computedOutboundSnappingPointsData = utils_1.SnappingMetadataComputingUtils.cloneSnappingPointsArray(source.computedOutboundSnappingPointsData);
        this.computedRecommendedFastenerPointsDataInitial = utils_1.SnappingMetadataComputingUtils.cloneSnappingPointsArray(source.computedRecommendedFastenerPointsDataInitial);
        this.computedRecommendedFastenerPointsData = utils_1.SnappingMetadataComputingUtils.cloneSnappingPointsArray(source.computedRecommendedFastenerPointsData);
        this.computedSlotDataInitial = utils_1.SnappingMetadataComputingUtils.cloneSlotsArray(source.computedSlotDataInitial);
        (_a = this.computedSlotDataInitial) === null || _a === void 0 ? void 0 : _a.forEach((slot) => {
            // eslint-disable-next-line no-param-reassign
            slot.objectUUID = this.uuid;
        });
        this.computedSlotData = utils_1.SnappingMetadataComputingUtils.cloneSlotsArray(source.computedSlotData);
        (_b = this.computedSlotData) === null || _b === void 0 ? void 0 : _b.forEach((slot) => {
            // eslint-disable-next-line no-param-reassign
            slot.objectUUID = this.uuid;
            if (this.partDetails.panelDepth) {
                // eslint-disable-next-line no-param-reassign
                slot.depth = this.partDetails.panelDepth;
            }
        });
        this.alignmentAxisInitial = source.alignmentAxisInitial ? source.alignmentAxisInitial.clone() : null;
        this.masterSnappingPointsInitial = utils_1.Utils.makeVector3ArrayCopy(source.masterSnappingPointsInitial);
        this.hasSwappedMetadataPoints = source.hasSwappedMetadataPoints;
        if (this.collisionBox) {
            this.collisionBox.name = `X|${this.uuid}`;
        }
        if (this.outerBox) {
            this.outerBox.name = `OB|${this.uuid}`;
        }
        if (this.selectionBox) {
            this.selectionBox.name = `OBB|${this.uuid}`;
        }
        this.slicePlanes = source.slicePlanes.map((plane) => {
            return { normal: plane.normal.clone(), constant: plane.constant };
        });
        this.cutContour = source.cutContour.map((point) => point.clone());
        if (source.copyInfo) {
            this.copyInfo = Object.assign({}, source.copyInfo);
        }
        this.positionOnDown = source.positionOnDown.clone();
        this.quaternionOnDown = source.quaternionOnDown.clone();
        this.scaleOnDown = source.scaleOnDown.clone();
        return this;
    }
    setObjectDirectionNormal(normal) {
        this.directionNormal = normal;
    }
    setCutContour(points) {
        this.cutContour = points;
    }
    getTransformedCutContour() {
        this.updateMatrixWorld();
        return this.cutContour.map((point) => point.clone().applyMatrix4(this.matrixWorld));
    }
    addConnectionItems(...connectionItem) {
        this.connectedItems.push(...connectionItem);
    }
    removeConnectionItems(...uuids) {
        this.connectedItems = this.connectedItems.filter((item) => !uuids.includes(item.uuid));
    }
    clearConnectionItems() {
        this.connectedItems = [];
    }
    getInboundSnappingPointsRaw() {
        if (this.metadataNeedsUpdate) {
            this.updateMetadata();
        }
        return this.partMetadata.inboundSnappingPoints;
    }
    getOutboundSnappingPointsRaw() {
        if (this.metadataNeedsUpdate) {
            this.updateMetadata();
        }
        return this.partMetadata.outboundSnappingPoints;
    }
    getRecommendedFastenerPointsRaw() {
        if (this.metadataNeedsUpdate) {
            this.updateMetadata();
        }
        return this.partMetadata.recommendedFastenerPoints;
    }
    getRectangles() {
        if (this.metadataNeedsUpdate) {
            this.updateMetadata();
        }
        return this.partMetadata.rectangles;
    }
    getInboundSnappingPoints() {
        var _a, _b;
        if (this.metadataNeedsUpdate) {
            this.updateMetadata();
        }
        return (_b = (_a = this.computedInboundSnappingPointsData) === null || _a === void 0 ? void 0 : _a.map(utils_1.SnappingMetadataComputingUtils.cloneSnappingPoint)) !== null && _b !== void 0 ? _b : null;
    }
    getOutboundSnappingPoints() {
        var _a, _b;
        if (this.metadataNeedsUpdate) {
            this.updateMetadata();
        }
        return (_b = (_a = this.computedOutboundSnappingPointsData) === null || _a === void 0 ? void 0 : _a.map(utils_1.SnappingMetadataComputingUtils.cloneSnappingPoint)) !== null && _b !== void 0 ? _b : null;
    }
    getRecommendedFastenerPoints() {
        var _a, _b;
        if (this.metadataNeedsUpdate) {
            this.updateMetadata();
        }
        return (_b = (_a = this.computedRecommendedFastenerPointsData) === null || _a === void 0 ? void 0 : _a.map(utils_1.SnappingMetadataComputingUtils.cloneSnappingPoint)) !== null && _b !== void 0 ? _b : null;
    }
    getSlots() {
        var _a, _b;
        if (this.metadataNeedsUpdate) {
            this.updateMetadata();
        }
        return (_b = (_a = this.computedSlotData) === null || _a === void 0 ? void 0 : _a.map(utils_1.SnappingMetadataComputingUtils.cloneSlot)) !== null && _b !== void 0 ? _b : null;
    }
    getAlignmentAxis() {
        if (this.metadataNeedsUpdate) {
            this.updateMetadata();
        }
        return this.partMetadata.alignmentAxis;
    }
    getMasterSnappingPoints() {
        if (this.metadataNeedsUpdate) {
            this.updateMetadata();
        }
        return this.partMetadata.masterSnappingPoints;
    }
    getMasterSnappingPoint(index = 0) {
        if (this.metadataNeedsUpdate) {
            this.updateMetadata();
        }
        const masterSnappingPoints = this.getMasterSnappingPoints();
        return masterSnappingPoints ? masterSnappingPoints[index] : null;
    }
    get hasSnappingMetadata() {
        return (!!this.partMetadata.inboundSnappingPoints ||
            !!this.partMetadata.outboundSnappingPoints ||
            !!this.partMetadata.rectangles);
    }
    getLength() {
        return this.getSize().getComponent(consts_3.consts.DP_LENGTH_COMPONENT_INDEX);
    }
    getWidth() {
        return this.getSize().getComponent(consts_3.consts.DP_WIDTH_COMPONENT_INDEX);
    }
    getHeight() {
        return this.getSize().getComponent(consts_3.consts.DP_HEIGHT_COMPONENT_INDEX);
    }
    getCollisionExcludeIds() {
        return [this.uuid];
    }
    getConnectionExcludeIDs() {
        return this.connectedItems.map((item) => item.uuid);
    }
    setSizeX(x, validateSize = true) {
        return this.setSizeComponent(0, x, validateSize);
    }
    setSizeY(y, validateSize = true) {
        return this.setSizeComponent(1, y, validateSize);
    }
    setSizeZ(z, validateSize = true) {
        return this.setSizeComponent(2, z, validateSize);
    }
    setSizeComponent(index, value, validateSize = true) {
        return this.setScaleComponent(index, value / this.getGeometrySize(_v1).getComponent(index), validateSize);
    }
    /**
     * Set the physical size of the object.
     */
    setSize(size, validateSize = true) {
        return this.setScale(_v1.copy(size).divide(this.getGeometrySize(_v2)), validateSize);
    }
    /**
     * Calculate the size of the object depending on its scale and underlying geometry size.
     */
    getSize(useMetadata = true) {
        return this.getGeometrySize(new three_1.Vector3(), useMetadata).multiply(this.getScale());
    }
    updateMatrixWorld(force = false) {
        // Change scale of the boxes in order to save their paddings (e.g. padding for collision box)
        // or just have the same size with the parent object (this is actual for the some special
        // cases, such as wire mesh panels) after applying parent's matrix to them.
        const objectSize = this.getSize();
        if (this.outerBox) {
            this.prepareBoxSizeBeforeMatrixUpdating(this.outerBox, objectSize, consts_3.consts.OUTER_BOX_PADDING);
        }
        if (this.collisionBox) {
            this.prepareBoxSizeBeforeMatrixUpdating(this.collisionBox, objectSize, consts_3.consts.COLLISION_BOX_PADDING);
        }
        if (this.selectionBox) {
            this.prepareBoxSizeBeforeMatrixUpdating(this.selectionBox, objectSize, consts_3.consts.SELECTION_BOX_PADDING);
        }
        super.updateMatrixWorld(force);
    }
    prepareBoxSizeBeforeMatrixUpdating(box, requiredSize, requiredPadding) {
        const boxSize = requiredSize.clone().addScalar(2 * requiredPadding);
        const tempBoxSize = boxSize.divide(this.scale);
        box.scale.copy(tempBoxSize);
    }
    lookAt(vector, y, z) {
        if (vector instanceof three_1.Vector3) {
            super.lookAt(vector);
        }
        else {
            super.lookAt(vector, y, z);
        }
        this.updateObjectDirections();
        this.metadataNeedsUpdate = true;
    }
    applyMatrix4(matrix) {
        super.applyMatrix4(matrix);
        this.updateObjectDirections();
        this.metadataNeedsUpdate = true;
    }
    // Scale commands
    getScale() {
        return this.scale;
    }
    setScale(scale, validateSize = true) {
        return this.addScale(_v1.copy(scale).sub(this.getScale()), validateSize);
    }
    setScaleX(x, validateSize = true) {
        return this.setScaleComponent(0, x, validateSize);
    }
    setScaleY(y, validateSize = true) {
        return this.setScaleComponent(1, y, validateSize);
    }
    setScaleZ(z, validateSize = true) {
        return this.setScaleComponent(2, z, validateSize);
    }
    setScaleComponent(index, value, validateSize = true) {
        return this.addScale(_v1.set(0, 0, 0).setComponent(index, value - this.getScale().getComponent(index)), validateSize);
    }
    addScale(growth, validateSize = true) {
        if (utils_1.Utils.areVectorsEqual(growth, utils_1.Utils.zeroVector)) {
            return this;
        }
        this.scale.add(growth);
        if (validateSize) {
            this.checkAndFixSize();
        }
        this.metadataNeedsUpdate = true;
        return this;
    }
    addScaleX(xGrowth, validateSize = true) {
        return this.addScaleComponent(0, xGrowth, validateSize);
    }
    addScaleY(yGrowth, validateSize = true) {
        return this.addScaleComponent(1, yGrowth, validateSize);
    }
    addScaleZ(zGrowth, validateSize = true) {
        return this.addScaleComponent(2, zGrowth, validateSize);
    }
    addScaleComponent(index, value, validateSize = true) {
        return this.addScale(_v1.set(0, 0, 0).setComponent(index, value), validateSize);
    }
    // Translation commands
    setPosition(position) {
        return this.translate(_v1.copy(position).sub(this.position));
    }
    setPositionX(x) {
        return this.setPositionComponent(0, x);
    }
    setPositionY(y) {
        return this.setPositionComponent(1, y);
    }
    setPositionZ(z) {
        return this.setPositionComponent(2, z);
    }
    setPositionComponent(index, value) {
        return this.translate(_v1.set(0, 0, 0).setComponent(index, value - this.position.getComponent(index)));
    }
    translate(offset, worldSpace = true) {
        if (utils_1.Utils.areVectorsEqual(offset, utils_1.Utils.zeroVector)) {
            return this;
        }
        _v1.copy(offset);
        if (!worldSpace) {
            _v1.applyQuaternion(this.quaternion);
        }
        this.position.add(_v1);
        this.slicePlanes.forEach((plane) => {
            // eslint-disable-next-line no-param-reassign
            plane.constant -= _v1.dot(plane.normal);
        });
        this.metadataNeedsUpdate = true;
        return this;
    }
    translateOnAxis(axis, distance) {
        return this.translate(_v1.copy(axis).multiplyScalar(distance), false);
    }
    // Rotation commands
    applyQuaternion(q) {
        return this.rotate(q);
    }
    rotateOnAxis(axis, angle) {
        _q1.setFromAxisAngle(axis, angle);
        return this.rotate(_q1, false);
    }
    rotateOnWorldAxis(axis, angle) {
        _q1.setFromAxisAngle(axis, angle);
        return this.rotate(_q1);
    }
    rotate(q, worldSpace = true, rotationPoint = null) {
        _q1.copy(q);
        if (utils_1.Utils.areNotEqual(_q1.lengthSq(), 1.0)) {
            _q1.normalize();
        }
        if (utils_1.Utils.areQuaternionsEqual(_q1, utils_1.Utils.identityQuaternion)) {
            return this;
        }
        if (rotationPoint) {
            this.position.sub(rotationPoint);
            this.position.applyQuaternion(_q1);
            this.position.add(rotationPoint);
        }
        this.rotateSlicePlanes(rotationPoint !== null && rotationPoint !== void 0 ? rotationPoint : this.position, _q1);
        if (worldSpace) {
            this.quaternion.premultiply(_q1);
        }
        else {
            this.quaternion.multiply(_q1);
        }
        this.updateObjectDirections();
        this.metadataNeedsUpdate = true;
        return this;
    }
    setRotation(q, rotationPoint = null) {
        const deltaRotation = _q2.copy(q).multiply(_q3.copy(this.quaternion).invert());
        if (rotationPoint) {
            return this.rotate(deltaRotation, true, rotationPoint);
        }
        if (utils_1.Utils.areQuaternionsEqual(q, this.quaternion)) {
            return this;
        }
        this.rotateSlicePlanes(this.position, deltaRotation);
        this.quaternion.copy(q);
        this.updateObjectDirections();
        this.metadataNeedsUpdate = true;
        return this;
    }
    setRotationFromAxisAngle(axis, angle) {
        _q1.setFromAxisAngle(axis, angle);
        return this.setRotation(_q1);
    }
    setRotationFromEuler(euler) {
        _q1.setFromEuler(euler);
        return this.setRotation(_q1);
    }
    setRotationFromMatrix(m) {
        _q1.setFromRotationMatrix(m);
        return this.setRotation(_q1);
    }
    setRotationFromQuaternion(q) {
        return this.setRotation(q);
    }
    setRotationAroundBBoxCenter(q, useMetadata = true) {
        const center = utils_1.Utils.getAABBoxCenter(this, useMetadata);
        return this.setRotation(q, center);
    }
    rotateAroundBBoxCenter(q, useMetadata = true) {
        const center = utils_1.Utils.getAABBoxCenter(this, useMetadata);
        return this.rotate(q, true, center);
    }
    rotateSlicePlanes(rotationPoint, rotation) {
        this.slicePlanes.forEach((plane) => {
            const rotatedPlane = utils_1.Utils.rotatePlane(new three_1.Plane(plane.normal, plane.constant), rotationPoint, rotation);
            // eslint-disable-next-line no-param-reassign
            plane.normal = rotatedPlane.normal;
            // eslint-disable-next-line no-param-reassign
            plane.constant = rotatedPlane.constant;
        });
    }
    /**
     * Swaps inbound snapping points with recommended fastener points. Also translates master snapping point with inbound snapping points
     */
    swapMetadataPoints() {
        var _a, _b, _c;
        if (!((_a = this.computedRecommendedFastenerPointsDataInitial) === null || _a === void 0 ? void 0 : _a.length) ||
            !((_b = this.computedInboundSnappingPointsDataInitial) === null || _b === void 0 ? void 0 : _b.length)) {
            return;
        }
        const temp = this.computedInboundSnappingPointsDataInitial;
        this.computedInboundSnappingPointsDataInitial = this.computedRecommendedFastenerPointsDataInitial;
        this.computedRecommendedFastenerPointsDataInitial = temp;
        if ((_c = this.masterSnappingPointsInitial) === null || _c === void 0 ? void 0 : _c.length) {
            const delta = this.computedRecommendedFastenerPointsDataInitial[0].origin.z -
                this.computedInboundSnappingPointsDataInitial[0].origin.z;
            this.masterSnappingPointsInitial.forEach((point) => point.setZ(point.z - delta));
        }
        this.hasSwappedMetadataPoints = !this.hasSwappedMetadataPoints;
        this.metadataNeedsUpdate = true;
    }
    /**
     * Rotate object by 180 degrees around the specified axis. Also swaps inbound snapping points and recommended fastener points;
     * and compensates translation to save bounding box position
     * @param axis rotation axis that is used to perform rotation. Must be perpendicular to object normal
     * @param compensateTranslation compensate or not translation to save object bbox position
     */
    flipAroundMasterSnappingPoint(axis, masterSnappingPointIndex, compensateTranslation = true) {
        if (!utils_1.Utils.areVectorsPerpendicular(axis, this.directionNormal)) {
            return this;
        }
        this.rotate(new three_1.Quaternion().setFromAxisAngle(axis, Math.PI), true, this.getMasterSnappingPoint(masterSnappingPointIndex !== null && masterSnappingPointIndex !== void 0 ? masterSnappingPointIndex : 0));
        this.swapMetadataPoints();
        if (compensateTranslation) {
            const inboundSnappingPoints = this.getInboundSnappingPointsRaw();
            const recommendedFastenerPoints = this.getRecommendedFastenerPointsRaw();
            if ((inboundSnappingPoints === null || inboundSnappingPoints === void 0 ? void 0 : inboundSnappingPoints.length) && (recommendedFastenerPoints === null || recommendedFastenerPoints === void 0 ? void 0 : recommendedFastenerPoints.length)) {
                this.translate(recommendedFastenerPoints[0].clone().sub(inboundSnappingPoints[0]));
            }
        }
        this.metadataNeedsUpdate = true;
        return this;
    }
    // eslint-disable-next-line class-methods-use-this
    checkAndFixSize() {
        return false;
    }
    // eslint-disable-next-line class-methods-use-this
    checkAndFixSizeByAxis(scale, axisNumber, minValue, maxValue) {
        let sizeByAxis = scale.getComponent(axisNumber) * minValue;
        let fixed = false;
        // Check min size
        if (sizeByAxis < minValue) {
            sizeByAxis = minValue;
            fixed = true;
        }
        // Check max size
        if (sizeByAxis > maxValue) {
            sizeByAxis = maxValue;
            fixed = true;
        }
        if (fixed) {
            scale.setComponent(axisNumber, sizeByAxis / minValue);
        }
        return fixed;
    }
    /**
     * Calculate the size of the underlying geometry. If bounding box size metadata is missing,
     * it assumes that geometry bounding box is already computed.
     *
     * @param target vector to which the geometry size should be written. If it's null,
     * a new vector will be allocated.
     * @param useMetadata whether to use predefined geometry size from metadata or not.
     * @returns the target vector or a new allocated vector containing the geometry size.
     */
    getGeometrySize(target = null, useMetadata = true) {
        var _a, _b;
        return useMetadata && this.partMetadata.boundingBoxSize
            ? (target === null || target === void 0 ? void 0 : target.copy(this.partMetadata.boundingBoxSize)) || this.partMetadata.boundingBoxSize.clone()
            : (_b = (_a = this.mesh.geometry.boundingBox) === null || _a === void 0 ? void 0 : _a.getSize(target !== null && target !== void 0 ? target : new three_1.Vector3())) !== null && _b !== void 0 ? _b : new three_1.Vector3();
    }
    updateMetadata() {
        this.updateMatrix();
        const objectMatrix = this.matrix;
        const objectQuaternion = this.quaternion;
        if (this.computedSlotDataInitial) {
            if (this.partMetadata.rectangles) {
                for (let idx = 0; idx < this.partMetadata.rectangles.length; idx += 1) {
                    this.updateMetadataPointArray(this.partMetadata.rectangles[idx].points, this.computedSlotDataInitial[idx].points, objectMatrix);
                }
            }
            this.computedSlotData = this.computedSlotDataInitial.map((slot) => {
                const result = utils_1.SnappingMetadataComputingUtils.updateSlot(slot, this.matrix, this.getLength());
                result.objectUUID = this.uuid;
                return result;
            });
        }
        if (this.computedInboundSnappingPointsDataInitial) {
            this.updateMetadataSnappingPointArray(this.partMetadata.inboundSnappingPoints, this.computedInboundSnappingPointsDataInitial, objectMatrix);
            this.computedInboundSnappingPointsData = this.computedInboundSnappingPointsDataInitial.map((point) => {
                const result = utils_1.SnappingMetadataComputingUtils.updateSnappingPoint(point, this.matrix);
                result.objectUUID = this.uuid;
                return result;
            });
        }
        if (this.computedOutboundSnappingPointsDataInitial) {
            this.updateMetadataSnappingPointArray(this.partMetadata.outboundSnappingPoints, this.computedOutboundSnappingPointsDataInitial, objectMatrix);
            this.computedOutboundSnappingPointsData = this.computedOutboundSnappingPointsDataInitial.map((point) => {
                const result = utils_1.SnappingMetadataComputingUtils.updateSnappingPoint(point, this.matrix);
                result.objectUUID = this.uuid;
                return result;
            });
        }
        if (this.computedRecommendedFastenerPointsDataInitial) {
            this.updateMetadataSnappingPointArray(this.partMetadata.recommendedFastenerPoints, this.computedRecommendedFastenerPointsDataInitial, objectMatrix);
            this.computedRecommendedFastenerPointsData = this.computedRecommendedFastenerPointsDataInitial.map((point) => {
                const result = utils_1.SnappingMetadataComputingUtils.updateSnappingPoint(point, this.matrix);
                result.objectUUID = this.uuid;
                return result;
            });
        }
        // update master snapping points
        this.updateMetadataPointArray(this.partMetadata.masterSnappingPoints, this.masterSnappingPointsInitial, objectMatrix);
        if (this.alignmentAxisInitial && this.partMetadata.alignmentAxis) {
            this.partMetadata.alignmentAxis.copy(this.alignmentAxisInitial).applyQuaternion(objectQuaternion).normalize();
        }
        this.metadataNeedsUpdate = false;
    }
    // eslint-disable-next-line class-methods-use-this
    updateMetadataSnappingPointArray(destination, source, transformation) {
        if (!destination || !source) {
            return;
        }
        for (let idx = 0; idx < destination.length; idx += 1) {
            destination[idx].copy(source[idx].origin).applyMatrix4(transformation);
        }
    }
    // eslint-disable-next-line class-methods-use-this
    updateMetadataPointArray(destination, source, transformation) {
        if (!destination || !source) {
            return;
        }
        for (let i = 0; i < destination.length; i += 1) {
            destination[i].copy(source[i]).applyMatrix4(transformation);
        }
    }
    updateObjectDirections() {
        this.directionNormal.copy(consts_3.consts.DP_UP_DIR).applyQuaternion(this.quaternion).normalize();
        this.xDirection.copy(consts_4.WORLD_AXES.X).applyQuaternion(this.quaternion).normalize();
        this.yDirection.copy(consts_4.WORLD_AXES.Y).applyQuaternion(this.quaternion).normalize();
        this.zDirection.copy(consts_4.WORLD_AXES.Z).applyQuaternion(this.quaternion).normalize();
        this.insertedVertically = utils_1.Utils.areVectorsCollinear(this.directionNormal, consts_3.consts.DP_UP_DIR);
    }
    get isScalable() {
        // built into slots panel
        if (this.type === types_2.ITEM_TYPE.PANEL && this.mesh.geometry instanceof three_1.ExtrudeGeometry) {
            return false;
        }
        if (this.type === types_2.ITEM_TYPE.COMPONENT && notScalingTypes.includes(this.partDetails.componentType)) {
            return false;
        }
        return this.partDetails.isScalable;
    }
    get isMovable() {
        if (this.type === types_2.ITEM_TYPE.COMPONENT && notMovingTypes.includes(this.partDetails.componentType)) {
            return false;
        }
        return !(this.type === types_2.ITEM_TYPE.COMPONENT &&
            this.partDetails.componentType === types_2.COMPONENT_TYPE.TSLOT_COVER &&
            this.connectedItems.length);
    }
    get isRotatable() {
        if (this.type === types_2.ITEM_TYPE.COMPONENT && notRotatingTypes.includes(this.partDetails.componentType)) {
            return false;
        }
        return !(this.type === types_2.ITEM_TYPE.COMPONENT &&
            this.partDetails.componentType === types_2.COMPONENT_TYPE.TSLOT_COVER &&
            this.connectedItems.length);
    }
    // eslint-disable-next-line class-methods-use-this
    get scalingAxes() {
        return undefined;
    }
    // eslint-disable-next-line class-methods-use-this
    get isSnappable() {
        return true;
    }
    /** List of object that should be removed, moved, rotated together with the object. For example end covers with extrusion */
    // eslint-disable-next-line class-methods-use-this, @typescript-eslint/no-unused-vars, prettier/prettier
    getTransformChildObjects(forDeleting = false) {
        // forDeleting used in overridden versions
        return [];
    }
    computeInitialSnappingMetadata() {
        var _a;
        const oldPosition = this.position.clone();
        const oldQuaternion = this.quaternion.clone();
        const oldSize = this.getSize();
        this.setRotation(utils_1.Utils.identityQuaternion);
        this.setPosition(utils_1.Utils.zeroVector);
        if (this.partDetails.isScalable) {
            this.setScaleZ(consts_3.consts.DEFAULT_SCALE_FOR_EXTRUSIONS);
        }
        this.computedSlotDataInitial = this.getRectangles() && utils_1.SnappingMetadataComputingUtils.calculateSlots(this);
        this.computedInboundSnappingPointsDataInitial =
            this.getInboundSnappingPointsRaw() && utils_1.SnappingMetadataComputingUtils.calculateInboundSnappingPoints(this);
        this.computedOutboundSnappingPointsDataInitial =
            this.getOutboundSnappingPointsRaw() && utils_1.SnappingMetadataComputingUtils.calculateOutboundSnappingPoints(this);
        this.computedRecommendedFastenerPointsDataInitial =
            this.getRecommendedFastenerPointsRaw() && utils_1.SnappingMetadataComputingUtils.calculateRecommendedFastenerPoints(this);
        this.masterSnappingPointsInitial = utils_1.Utils.makeVector3ArrayCopy(this.getMasterSnappingPoints());
        this.alignmentAxisInitial = ((_a = this.getAlignmentAxis()) === null || _a === void 0 ? void 0 : _a.clone()) || null;
        this.setPosition(oldPosition);
        this.setRotation(oldQuaternion);
        this.setSize(oldSize);
        this.updateMetadata();
    }
    setCatalogProps(catalogItem) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
        const { partDetails } = this;
        const partId = catalogItem.item_number;
        partDetails.isConvex = (0, catalogUtils_1.isConvexItem)(partId);
        partDetails.itemNumber = partId;
        partDetails.itemType = (_b = (_a = catalogItem.itemType) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '';
        partDetails.componentType = (_d = (_c = catalogItem.componentType) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : '';
        partDetails.extrusionType = (_f = (_e = catalogItem.extrusionType) === null || _e === void 0 ? void 0 : _e.name) !== null && _f !== void 0 ? _f : '';
        partDetails.extrusionProfileType = (_j = (_h = (_g = catalogItem.extrusionType) === null || _g === void 0 ? void 0 : _g.extrusionProfileType) === null || _h === void 0 ? void 0 : _h.name) !== null && _j !== void 0 ? _j : '';
        partDetails.isScalable = (_k = catalogItem.is_scalable) !== null && _k !== void 0 ? _k : false;
        partDetails.scaleAxes = (_l = catalogItem.scale_axes) !== null && _l !== void 0 ? _l : '-Z';
        partDetails.size = (0, utils_2.getItemProperty)(catalogItem, types_1.ITEM_PROPERTY_NAMES.SIZE);
        partDetails.unitOfMeasurementId = (_o = (_m = catalogItem.unitOfMeasurement) === null || _m === void 0 ? void 0 : _m.id) !== null && _o !== void 0 ? _o : 0;
        partDetails.mountTo = (_p = catalogItem.mountTo) !== null && _p !== void 0 ? _p : [];
        partDetails.includedFastenersCount = partDetails.mountTo.reduce((count, mountTo) => count +
            mountTo.compatibleFasteners
                .filter((compatibleFastener) => compatibleFastener.type === consts_2.INCLUDED)
                .reduce((totalQuantity, includedFasteners) => totalQuantity + includedFasteners.quantity, 0), 0);
        partDetails.slotThickness = Number((_q = catalogItem.extrusionType) === null || _q === void 0 ? void 0 : _q.slotThickness) || 0;
        partDetails.panelDepth = Number((_r = catalogItem.extrusionType) === null || _r === void 0 ? void 0 : _r.panelDepth) || null;
        partDetails.seriesIds = (_t = (_s = catalogItem.series) === null || _s === void 0 ? void 0 : _s.map(({ id }) => id)) !== null && _t !== void 0 ? _t : [];
        if (partDetails.itemType === types_2.ITEM_TYPE.COMPONENT) {
            if (partDetails.itemNumber === '655078' || // – hinge
                partDetails.itemNumber === '655083' || // – hinge
                partDetails.itemNumber === '655076' || // – door handle
                partDetails.itemNumber === '653056' || // – bracket 1
                partDetails.itemNumber === '653051' || // – bracket 2
                partDetails.itemNumber === '653045' || // – bracket 2
                partDetails.itemNumber === '653073' || // – gusset for 1 slot
                partDetails.itemNumber === '653075' // – gusset for 2 slots
            ) {
                this.isAxisPresent = true;
            }
            // Change axis into x for selected demo parts
            if (partDetails.itemNumber === '655060' || // – door handle
                partDetails.itemNumber === '655275' || // – floor mount for 1 slot
                partDetails.itemNumber === '655277' // – floor mount for 2 slot
            ) {
                this.isAxisPresent = true;
                this.axis[1] = new three_1.Vector3(1, 0, 0);
            }
            if (catalogItem.is_scalable && ((_u = catalogItem.componentType) === null || _u === void 0 ? void 0 : _u.name) === types_2.COMPONENT_TYPE.PANEL) {
                utils_1.Utils.addWireMeshGeometry(this);
                const stockWidth = (0, utils_2.getItemProperty)(catalogItem, consts_1.ITEM_STOCK_SIZE_PROPERTIES.STOCK_WIDTH);
                if ((0, utils_2.isNumber)(stockWidth !== null && stockWidth !== void 0 ? stockWidth : '')) {
                    partDetails.maxStockWidth = Number(stockWidth);
                }
            }
        }
        const thickness = (0, utils_2.getItemProperty)(catalogItem, types_1.ITEM_PROPERTY_NAMES.THICKNESS);
        if ((0, utils_2.isNumber)(thickness !== null && thickness !== void 0 ? thickness : '')) {
            partDetails.thickness = (0, utils_3d_1.roundTo3)(Number(thickness));
        }
        if (this.isScalable) {
            const stockLengthProperty = (0, utils_2.getItemPropertyDetails)(catalogItem, consts_1.ITEM_STOCK_SIZE_PROPERTIES.STOCK_LENGTH);
            if (stockLengthProperty && (0, utils_2.isNumber)((_v = stockLengthProperty.value) !== null && _v !== void 0 ? _v : '')) {
                partDetails.maxStockLength =
                    ((_w = stockLengthProperty.measurementUnit) === null || _w === void 0 ? void 0 : _w.name) === types_1.MEASUREMENT_UNIT.METRIC
                        ? Number(stockLengthProperty.value) * consts_3.consts.M_TO_FT * consts_3.consts.FT_TO_INCH
                        : Number(stockLengthProperty.value);
            }
        }
    }
    deleteBoxes() {
        const toRemoveBoxes = [];
        const addToRemoveBoxes = (boxPrefix) => {
            const boxName = boxPrefix + this.uuid;
            const box = this.children.find((child) => child.name === boxName);
            if (box) {
                toRemoveBoxes.push(box);
            }
        };
        addToRemoveBoxes(consts_3.consts.OUTER_BOX_PREFIX);
        addToRemoveBoxes(consts_3.consts.COLLISION_BOX_PREFIX);
        addToRemoveBoxes(consts_3.consts.OBB_PREFIX);
        this.remove(...toRemoveBoxes);
    }
    initBoxes() {
        this.deleteBoxes();
        const outerBox = utils_1.Utils.createOuterBox(this);
        this.add(outerBox);
        this.outerBox = outerBox;
        const collisionBox = utils_1.Utils.createCollisionBox(this);
        this.add(collisionBox);
        this.collisionBox = collisionBox;
        const selectionBox = utils_1.Utils.createSelectionBox(this);
        this.add(selectionBox);
        this.selectionBox = selectionBox;
    }
    testIntersection(otherObject) {
        if (this.mesh.geometry.boundsTree) {
            const thisObjectMatrix = this.getAdjustedMatrixForIntersectionTesting();
            const otherObjectMatrix = otherObject.getAdjustedMatrixForIntersectionTesting();
            const transformMatrix = tempMatrix4.copy(thisObjectMatrix).invert().multiply(otherObjectMatrix);
            return this.mesh.geometry.boundsTree.intersectsGeometry(otherObject.mesh.geometry, transformMatrix);
        }
        return utils_1.Utils.getOBB(this).intersectsOBB(utils_1.Utils.getOBB(otherObject), consts_3.consts.COLLISION_PRECISION);
    }
    getAdjustedMatrixForIntersectionTesting() {
        this.updateMatrixWorld();
        const boundingBox = (0, utils_3d_1.getAABBox)(this);
        const boundingBoxSize = boundingBox.getSize(new three_1.Vector3());
        const boundingBoxCenter = boundingBox.getCenter(new three_1.Vector3());
        const adjustScaleVector = boundingBoxSize
            .clone()
            .subScalar(consts_3.consts.DOUBLE_COLLISION_PRECISION)
            .divide(boundingBoxSize);
        return this.matrixWorld
            .clone()
            .premultiply(tempMatrix4.makeTranslation(-boundingBoxCenter.x, -boundingBoxCenter.y, -boundingBoxCenter.z))
            .premultiply(tempMatrix4.makeScale(adjustScaleVector.x, adjustScaleVector.y, adjustScaleVector.z))
            .premultiply(tempMatrix4.makeTranslation(boundingBoxCenter.x, boundingBoxCenter.y, boundingBoxCenter.z));
    }
    setTransparency(transparent = false, opacity = 1.0) {
        const meshMaterial = this.mesh.material;
        meshMaterial.setValues({ transparent, opacity });
    }
    /**
     * This method cooks `this` instance as a replacement for given replacement candidate using below algorithm:
     * 1. Initialize boxes (it is necessary for the tools to work later).
     * 2. Copy the properties of the replacement candidate that needs to be preserved. These will be copied back when replacement candidate acquires new look.
     *    Some of these properties are required for computing snapping metadata correctly.
     * 3. Update the world matrix. This is needed for correct cutting if required.
     * 4. Cut the object if needed.
     *    If the object is cut then remove old mesh, set the new mesh as first child and remove it from the end. (this is necessary because of the way copy() method handles children)
     * 5. Disable meta data update before computing snapping meta data, otherwise causes issue during computation if old object (replacement candidate) has less slots than the new one (replacement).
     * 6. Compute the snapping meta data (this will consider copied properties of the replacement candidate to compute correct snapping meta data).
     *
     * @param replacementCandidate The object on scene that is to be replaced.
     */
    cookAsReplacement(replacementCandidate) {
        //   1.
        this.initBoxes();
        //   2.
        this.positionOnDown.copy(replacementCandidate.positionOnDown.clone());
        this.quaternionOnDown.copy(replacementCandidate.quaternionOnDown.clone());
        this.scaleOnDown.copy(replacementCandidate.scaleOnDown.clone());
        this.position.copy(replacementCandidate.position.clone());
        this.rotation.copy(replacementCandidate.rotation.clone());
        this.quaternion.copy(replacementCandidate.quaternion.clone());
        this.setScale(replacementCandidate.getScale().clone());
        this.customScalingAxis = replacementCandidate.customScalingAxis;
        this.cutContour = replacementCandidate.cutContour.map((point) => point.clone());
        this.scalingAngle = replacementCandidate.scalingAngle;
        this.slicePlanes = replacementCandidate.slicePlanes.map((plane) => {
            return { normal: plane.normal.clone(), constant: plane.constant };
        });
        //   3.
        this.updateMatrixWorld();
        //   4.
        if (this.slicePlanes.length) {
            const slicingTool = new SlicingTool_3d_1.default(this);
            slicingTool.cutObject();
            if (slicingTool.clipMesh) {
                this.remove(this.children[0]);
                this.children.unshift(slicingTool.clipMesh);
                this.children.pop();
            }
        }
        //   5.
        this.metadataNeedsUpdate = false;
        //   6.
        this.computeInitialSnappingMetadata();
    }
    /**
     * This method gives the cooked replacement copy of `this` instance for given replacement candidate.
     * @param replacementCandidate The object on scene that is to be replaced.
     * @returns Cooked replacement copy of `this` for given `replacementCandidate`.
     */
    getCookedReplacementCopy(replacementCandidate) {
        const replacement = this.clone();
        replacement.cookAsReplacement(replacementCandidate);
        return replacement;
    }
    /**
     * This method applies the new look to `this` instance using below algorithm:
     * 1. Clear the children. The children from new look will be added while copying (and they will be used during copy to set mesh, boxes, etc.)
     * 2. Copy the properties of new look using `copy()` method (`copy()` method takes care of many things).
     * @param newLook The new look to be applied to `this` instance.
     */
    acquireNewLook(newLook) {
        //   1.
        const childrenToRemove = this.children;
        this.remove(...childrenToRemove);
        //   2.
        this.copy(newLook);
    }
    /**
     * This method applies necessary precautions on the object after it acquires new look.
     * Override this method to apply the type specific post makeover precautions.
     * @param appliedLook   The new look that's been applied to `this` instance.
     */
    // eslint-disable-next-line class-methods-use-this, @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
    takePostMakeoverPrecautions(appliedLook) {
        // Intentionally empty: meant to be overridden by subclasses if needed.
    }
    /**
     * This is a generic method that returns `this` instance as an instance of given generic type.
     * @returns `this` instance as given type `T`.
     */
    as() {
        return this;
    }
}
exports.default = BaseObject3D;
